import { useState } from "react";
import { SecurityScreenWrapper, Subtitle, Title } from "./SecurityScreen.styled";
import { Icon } from "@iconify/react";
import { useMsal } from "@azure/msal-react";
import { loginRequest, tokenRequest } from "../../utils/msalConfig";
import Button from "@src/components/Button/Button";
import { ButtonVariant } from "@src/components/Button/Button.constants";

export const SecurityScreen = () => {
	const { instance } = useMsal();
	const [isAuthenticating, setIsAuthenticating] = useState(false);

	const handleLogin = async () => {
		setIsAuthenticating(true);
		try {
			// First, handle the login
			const loginResponse = await instance.loginPopup(loginRequest);

			if (loginResponse.account) {
				// Then acquire the token
				const tokenResponse = await instance.acquireTokenSilent({
					...tokenRequest,
					account: loginResponse.account
				});

				// Store the token
				sessionStorage.setItem("token", tokenResponse.accessToken);
				window.location.reload();
			}
		} catch (error) {
			console.error("Login failed:", error);
			setIsAuthenticating(false);
		}
	};

	return (
		<SecurityScreenWrapper>
			<Icon icon="material-symbols:security" fontSize={45} color="#54778E" />
			<Title>Unauthorized Access</Title>
			<Subtitle>You are not authorized to view this page.</Subtitle>
			<Subtitle>Please sign in with your Microsoft account to access the Event Mapping Tool or open it from Admin Portal.</Subtitle>
			<Button onClick={handleLogin} variant={ButtonVariant.Primary} disabled={isAuthenticating}>
				{isAuthenticating ? "Signing in..." : "Sign in with Microsoft"}
			</Button>
		</SecurityScreenWrapper>
	);
};